<template>
  <div>
    <!--彈出視窗-->
    <v-dialog v-model="visible" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex>
                <input ref="files" multiple
                       type="file" :name="uploadFieldName"
                       @change="handleFilesUpload()"
                       accept="image/*,.xlsx,.xls,.csv,.pdf,.doc,.docx,.ppt,.pptx" hidden>
                <v-btn color="success" dark text @click="chooseFile()">選擇檔案</v-btn>
              </v-flex>
            </v-flex>
          </v-layout>
          <div v-for="(col, i) of list" :key="`file_${i}`">
            <v-divider></v-divider>
            <span v-if="files && files.length > 0"> {{ files[i].name }}</span>
            <!--            <span v-else-if="col.item.fileName !== ''"> {{ col.item.fileName }}</span>-->
            <v-layout row wrap>
              <v-flex xs12>
                <v-select :items="tags"
                          item-text="name"
                          item-value="name"
                          v-model="col.item.category"
                          label="檔案類型"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="col.item.url !==''">
              <v-flex>
                <v-text-field
                  :label="`網址`"
                  background-color="#49bcfd"
                  outline
                  v-model="col.item.url"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex>
                <v-text-field
                  :label="`備註`"
                  background-color="#49bcfd"
                  outline
                  v-model="col.item.comment"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </div>
          <v-layout>
            <v-flex>
              <span style="color: red;" v-if="message !== ''">{{message}}</span>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelEvent">取消</v-btn>
          <v-btn color="primary" dark text :loading="loading" @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions } from "vuex";

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "FileAddDialog",
  props: {
    visible: Boolean,
    title: String,
    item: Object,
    isNew: Boolean,
    tags: Array,
  },
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      type: 0,
      menu: false,
      fileList:[],
      uploadFieldName: 'files',
      files: [],
      list: [],
      loading: false,
      message: '',
    };
  },
  created() {
  },
  computed: {
    editedItem() {
      return this.item;
    },
  },
  watch: {
    visible(value) {
      console.log(`file visible = ${value}`)
    }
  },
  beforeUpdate() {
    this.itemRefs = []
  },
  methods: {
    ...mapActions([
      "getProductId",
      'saveFileInfo'
    ]),
    chooseFile(){
      console.log('chooseFile');
      this.$refs.files.value = null;
      this.list = [];
      this.files = [];
      this.$refs.files.click();
    },
    handleFilesUpload() {
      console.log('handleFilesUpload');

      this.files = Array.from(this.$refs.files.files);
      console.log(this.files);
      for (let file of this.files){
        const item = {
          item: {
            fileName: file.name,
            comment :'',
            url:'',
            category: ''
          },
          file: file,
        }
        this.list.push(item);
      }
      // this.files = this.$refs.files.files;
    },
    confirmEvent() {
      this.messag = '';
      console.log(this.list);
      let checkCount = 0;
      for (let col of this.list){
        if (col.item.category === ''){
          checkCount += 1;
        }
      }

      if (checkCount > 0){
        this.message = '請選擇檔案類型！'
        return;
      }

      this.loading = true;
      for (let col of this.list){
        const reader = new FileReader();
        reader.onload = async (e) => {
          const fileData = e.target.result;
          const url = await this.uploadData(col.file.name, fileData);
          col.item.url = url;
          await this.saveFileData(col.item);
        }
        reader.readAsDataURL(col.file);
      }
      console.log(`上傳完成`);
      this.loading = false;
      this.messag = '';
      this.$emit("confirmEvent");
      // this.$emit("confirmEvent", { item: this.editedItem, files: this.files });
    },
    async uploadData(name, fileData){
      const res = await this.$store.dispatch('uploadImageData', {
        name: `fileList/${name}`,
        image: fileData,
      });
      return res;
    },
    async saveFileData(file){
      try {
        const res = await this.saveFileInfo({
          fileName: file.fileName,
          category: file.category,
          comment: file.comment,
          url: file.url,
        });
        const result = res.data;
        console.log(`saveFileInfo result ${JSON.stringify(result)}`);
      } catch (e) {
        console.log(`saveFileData error `, e);
      }
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    deleteEvent(){
      this.$emit("deleteEvent", this.editedItem.fileId);
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FileAddDialog.vue